import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './MultiPanelItem.sass';
import { SIZE } from '../../constants';
export class MultiPanelItem extends React.Component {
    divRef = React.createRef();
    // Pokud nebude musi dedit z React.PureComponent
    shouldComponentUpdate(nextProps) {
        return this.props.level !== nextProps.level || this.props.isClosed !== nextProps.isClosed;
    }
    handleTransitionEnd = (e) => {
        if (e.target === this.divRef.current) {
            this.props.onTransitionEnd?.(e);
        }
    };
    handleOpenBtnClick = (e) => {
        this.props.onOpenBtnClick(e, { data: this.props.data });
    };
    render() {
        let className = ` sg-multiPanelItem-priority-${this.props.priority}`;
        className += ` sg-multiPanelItem-level-${this.props.level}`;
        className += this.props.level > 1 ? ' sg-multiPanelItem-isOverlapped' : '';
        className += this.props.size === SIZE.SML ? ' sg-multiPanelItem-sml' : '';
        className += this.props.size === SIZE.MED ? ' sg-multiPanelItem-med' : '';
        className += this.props.size === SIZE.LRG ? ' sg-multiPanelItem-lrg' : '';
        return (_jsxs("div", { className: 'sg-multiPanelItem' + className, ref: this.divRef, onTransitionEnd: this.props.onTransitionEnd && this.handleTransitionEnd, children: [_jsx("div", { className: 'sg-multiPanelItem--content', 
                    // @ts-ignore
                    inert: this.props.level !== 1 || this.props.isClosed ? 'true' : undefined, children: this.props.children }), _jsx("button", { className: 'sg-multiPanelItem--btn', type: 'button', tabIndex: -1, onClick: this.handleOpenBtnClick, "data-test-id": this.props.testId ? `${this.props.testId}-button` : undefined })] }));
    }
}
//# sourceMappingURL=MultiPanelItem.js.map